import React from 'react';
import { Icon, Tag } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { returnDate } from '../common/utils';
import Coins from '../components/Coins';

export const ENV = process.env.NODE_ENV || 'development';
export const NETWORK = process.env.REACT_APP_NETWORK || 'testnet';
console.log(window.location.hostname)
export const API_URL =
	(window.location.hostname.indexOf('dash.testnet') < 0 && window.location.hostname.indexOf('localhost') < 0)
		? 'https://api.hollaex.network/v2'
		: 'https://api.testnet.hollaex.network/v2'
export const HOLLAEX_KIT =
	'https://github.com/hollaex/hollaex-kit/archive/master.zip';

export const BREAK_POINT = 1200;

export const CAPTCHA_SITE_KEY =
	process.env.REACT_APP_CAPTCHA_SITE_KEY ||
	'6LfgB6kUAAAAAAJI6CNSHdLrjDn8iFmZGxQDrcER';

export const LANGUAGE_KEY = `${ENV}_${NETWORK}_LANGUAGE`;

export const S3_IMAGE_URL = {
	production: 'https://bitholla.s3.ap-northeast-2.amazonaws.com',
	development: 'https://bitholla-sandbox.s3.ap-northeast-2.amazonaws.com'
};

export const LOGO_WHITE = '/assets/img/logo_white.png';
export const LOGO_BLACK = '/assets/img/logo_black.png';
export const BG_IMG = '/assets/img/hex-bg.jpg';
export const HOLLAEX_KIT_BG = '/assets/img/hollaex-kit-bg.jpg';
export const WALLET_DETAIL_BG = '/assets/img/wallet-background.jpg';

export const EXCHANGE_S3_IMAGE = (
	filename = 'bitholla-logo.png',
	exchange = 'public-holla-images'
) => {
	return `${S3_IMAGE_URL[ENV]}/exchange/${exchange}/${filename}?t=${new Date().getTime()}`;
};

export const COLLATERAL_TOTAL_AMOUNT = 500000;

export const MONTH_NAMES = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec'
];

export const PAGE_DESC = {
	main: {
		title: 'Overview',
		desc: ''
	},
	shell: {
		title: 'Kit Configuration',
		desc: 'This is Kit Configuration Page.'
	},
	mypage: {
		title: 'Edit Profile',
		desc: ''
	},
	reset: {
		title: 'Password & Security',
		desc: ''
	},
	product: {
		title: 'Product',
		desc: ''
	},
	token: {
		title: 'API Keys',
		desc: ''
	},
	newToken: {
		title: 'Generate Exchange Key',
		desc: ''
	},
	wallet: {
		title: 'My Wallet',
		desc:
			'You create your mainnet or testest wallets on this page by simply clicking the create wallet button'
	},
	vault: {
		title: 'Vault',
		desc: ''
	},
	'hollaex-kit': {
		title: 'HollaEx Kit',
		desc: ''
	}
};

export const NAV_LIST = [
	{
		key: 'home',
		url: '/',
		name: 'Dashboard'
	},
	{
		key: 'wallet',
		url: '/wallet',
		name: 'Wallets'
	},
	{
		key: 'plugin',
		url: '/plugin',
		name: 'Plugins'
	},
	// {
	// 	key: 'project',
	// 	url: '/project',
	// 	name: 'Projects'
	// }
];

export const GNB_LIST_PC = [
	{
		key: 'home',
		url: '/',
		name: 'Dashboard'
	},
	{
		key: 'exchange',
		url: '/exchange',
		name: 'Exchange'
	},
	{
		key: 'wallet',
		url: '/wallet',
		name: 'Wallets'
	},
	{
		key: 'plugin',
		url: '/plugin',
		name: 'Plugins'
	},
	{
		key: 'project',
		url: '/project',
		name: 'Projects'
	}
];

export const GNB_LIST_MOBILE = [
	{
		key: 'dashboard',
		url: '/dashboard',
		name: 'Dashboard'
	},
	{
		key: 'hosting',
		url: '/hosting',
		name: 'Hosting'
	},
	{
		key: 'general',
		url: '/general',
		name: 'General'
	},
	{
		key: 'users',
		url: '/users',
		name: 'Users'
	},
	{
		key: 'financial',
		url: '/financial',
		name: 'Assets'
	},
	{
		key: 'trade',
		url: '/trade',
		name: 'Markets'
	},
	{
		key: 'customize',
		url: '/customize',
		name: 'Customize'
	},
	// {
	// 	key: 'kyc',
	// 	url: '/kyc',
	// 	name: 'KYC'
	// },
	{
		key: 'verifyAgree',
		url: '/verifyAgree',
		name: 'Verification'
	},
	{
		key: 'billing',
		url: '/billing',
		name: 'Billing'
	},
	// {
	// 	key: 'collateral',
	// 	url: '/collateral',
	// 	name: 'Collateral'
	// }
];

export const EXPLORER_ENDPOINT = (currency, isTestnet) => {
	switch (currency) {
		case 'eth':
			return isTestnet
				? 'https://ropsten.etherscan.io/tx/'
				: 'https://etherscan.io/tx/';
		case 'btc':
			return isTestnet
				? 'https://live.blockcypher.com/btc-testnet/tx/'
				: 'https://live.blockcypher.com/btc/tx/';
		case 'xrp':
			return isTestnet
				? 'https://test.bithomp.com/explorer/'
				: 'https://bithomp.com/explorer/';
		case 'bch':
			return isTestnet
				? 'https://explorer.bitcoin.com/tbch/tx/'
				: 'https://explorer.bitcoin.com/bch/tx/';
		case 'hex':
			return isTestnet
				? 'https://ropsten.etherscan.io/tx/'
				: 'https://etherscan.io/tx/';
		case 'xht':
			return isTestnet
				? 'https://ropsten.etherscan.io/tx/'
				: 'https://etherscan.io/tx/';
		default:
			return isTestnet
				? 'https://ropsten.etherscan.io/tx/'
				: 'https://etherscan.io/tx/';
	}
};

export const TABLE_TOKEN_COLUMN = [
	{
		title: 'Name',
		dataIndex: 'name',
		width: '16%'
	},
	{
		title: 'Key',
		dataIndex: 'apiKey',
		width: '16%'
	},
	{
		title: 'Secret',
		dataIndex: 'secret',
		width: '16%'
	},
	{
		title: 'Date Generated',
		dataIndex: 'created',
		width: '16%',
		render: (d) => returnDate(d)
	},
	{
		title: 'Date Expired',
		dataIndex: 'expiry',
		width: '16%',
		render: (d) => returnDate(d)
	},
	{
		title: 'Revoke',
		dataIndex: 'revoked',
		width: '10%',
		render: (bool, row, index) => {
			const obj = {
				pathname: `/wallet/api-key/${row.id}`,
				state: { data: row }
			};
			if (!bool) {
				if (row.active) {
					return <Link to={obj}>Revoke</Link>;
				}
				return <span className="disabled">Inactive</span>;
			} else {
				return <span className="disabled">Revoked</span>;
			}
		}
	}
];

export const TABLE_WALLET_COLUMN = [
	{
		title: 'Name',
		dataIndex: 'name',
		width: '20%',
		render: (name, row) => {
			const obj = {
				pathname: `/wallet/${name}`,
				state: { data: row }
			};
			return (
				<Link to={obj} style={{ textDecoration: 'underline' }}>
					{name}
				</Link>
			);
		}
	},
	{
		title: 'Asset',
		dataIndex: 'currency',
		width: '20%',
		render: (d) => <Coins xs={true} type={d} />
	},
	{
		title: 'Created',
		dataIndex: 'created_at',
		width: '20%',
		render: (d) => returnDate(d)
	},
	{
		title: 'Type',
		dataIndex: 'type',
		width: '20%',
		render: (string) => string.charAt(0).toUpperCase() + string.slice(1)
	},
	{
		title: 'Network',
		dataIndex: 'is_testnet',
		width: '20%',
		render: (bool) =>
			bool ? (
				<span className="holla-label gray">Testnet</span>
			) : (
				<span className="holla-label green">Mainnet</span>
			)
	}
];

export const TABLE_TRANSACTION_COLUMN = [
	{
		title: 'Address',
		dataIndex: 'address',
		width: '20%'
	},
	{
		title: 'Date',
		dataIndex: 'created_at',
		width: '20%',
		render: (d) => returnDate(d)
	},
	{
		title: 'Amount',
		dataIndex: 'amount',
		width: '20%',
		render: (c, r) => {
			return r.type === 'deposit' ? `+ ${c}` : `- ${c}`;
		}
	},
	{
		title: 'Fee',
		dataIndex: 'fee',
		width: '20%'
	},
	{
		title: 'Status',
		dataIndex: 'is_confirmed',
		width: '20%',
		render: (c, r) => {
			return (
				<span>
					{c ? 'Complete' : 'Pending'}&nbsp;
					<a
						href={
							EXPLORER_ENDPOINT(r.currency, r.Wallet.is_testnet) + r.txid
						}
						title="explorer"
						target="_blank"
						rel="noopener noreferrer"
					>
						(VIEW)
					</a>
				</span>
			);
		}
	}
];

export const TABLE_ADDRESS_COLUMN = [
	{
		title: 'Date Created',
		dataIndex: 'created_at',
		width: '30%',
		render: (d, row) => {
			const date = returnDate(d);
			if (row.isNew) {
				return (
					<div>
						{date} <Tag color="blue">new</Tag>
					</div>
				);
			}
			return date;
		}
	},
	{
		title: 'Address',
		dataIndex: 'address',
		width: '70%',
		render: (d) => d
	}
];

export const ASSET_TYPE_LIST = [
	{ key: 'Bitcoin', value: 'btc' },
	{ key: 'Bitcoin Cash', value: 'bch' },
	{ key: 'Ripple', value: 'xrp' },
	{ key: 'Ethereum', value: 'eth' },
	{ key: 'HollaEx', value: 'hex' },
	{ key: 'HollaEx', value: 'xht' },
	{ key: 'Bitcoin Satoshi Vision', value: 'bsv' },
	{ key: 'USD Tether', value: 'usdt' },
	{ key: 'BNB', value: 'bnb' },
	{ key: 'UNUS SED LEO', value: 'leo' },
	{ key: 'Maker', value: 'mkr' },
	{ key: 'USD Coin', value: 'usdc' },
	{ key: 'BAT', value: 'bat' },
	{ key: 'Monero', value: 'xmr' },
	{ key: 'EOS', value: 'eos' },
	{ key: 'Litecoin', value: 'ltc' },
	{ key: 'Stellar', value: 'xlm' },
	{ key: 'Cardano', value: 'ada' },
	{ key: 'Tron', value: 'trx' },
	{ key: 'NEO', value: 'neo' },
	{ key: 'NEM', value: 'nem' },
	{ key: 'Ethereum Classic', value: 'etc' },
	{ key: 'Dash', value: 'dash' },
	{ key: 'IOTA', value: 'miota' },
	{ key: 'ZRX', value: 'zrx' },
	{ key: 'Gold Tether', value: 'xaut' }
];

export const ASSET_PROPERTIES = {
	btc: {
		IS_DEFAULT: true,
		ASSET_NAME: 'Bitcoin',
		ASSET_SYMBOL: 'btc',
		ASSET_COLOR: '#f7941d',
		ASSET_ALLOW_DEPOSITS: true,
		ASSET_ALLOW_WITHDRAWAL: true,
		ASSET_PROMOTE: false,
		ASSET_WITHDRAWAL_FEE: 0.001,
		ASSET_MINIMUM_WITHDRAWAL: 0.001,
		ASSET_MAXIMUM_WITHDRAWAL: 10000,
		ASSET_INCREMENT_AMOUNT: 0.001,
		ASSET_ACTIVATE: true,
		ASSET_ICON: '',
		deposit: {},
		withdraw: {}
	},
	xrp: {
		IS_DEFAULT: true,
		ASSET_NAME: 'Ripple',
		ASSET_SYMBOL: 'xrp',
		ASSET_COLOR: '#414042',
		ASSET_ALLOW_DEPOSITS: true,
		ASSET_ALLOW_WITHDRAWAL: true,
		ASSET_PROMOTE: false,
		ASSET_WITHDRAWAL_FEE: 0.001,
		ASSET_MINIMUM_WITHDRAWAL: 0.001,
		ASSET_MAXIMUM_WITHDRAWAL: 10000,
		ASSET_INCREMENT_AMOUNT: 0.001,
		ASSET_ACTIVATE: true,
		ASSET_ICON: '',
		deposit: {},
		withdraw: {}
	},
	hex: {
		IS_DEFAULT: true,
		ASSET_NAME: 'HollaEx Token',
		ASSET_SYMBOL: 'xht',
		ASSET_COLOR: '#000000',
		ASSET_ALLOW_DEPOSITS: true,
		ASSET_ALLOW_WITHDRAWAL: true,
		ASSET_PROMOTE: false,
		ASSET_WITHDRAWAL_FEE: 0.001,
		ASSET_MINIMUM_WITHDRAWAL: 0.001,
		ASSET_MAXIMUM_WITHDRAWAL: 10000,
		ASSET_INCREMENT_AMOUNT: 0.001,
		ASSET_ACTIVATE: true,
		ASSET_ICON: '',
		deposit: {},
		withdraw: {}
	},
	xht: {
		IS_DEFAULT: true,
		ASSET_NAME: 'HollaEx Token',
		ASSET_SYMBOL: 'xht',
		ASSET_COLOR: '#000000',
		ASSET_ALLOW_DEPOSITS: true,
		ASSET_ALLOW_WITHDRAWAL: true,
		ASSET_PROMOTE: false,
		ASSET_WITHDRAWAL_FEE: 0.001,
		ASSET_MINIMUM_WITHDRAWAL: 0.001,
		ASSET_MAXIMUM_WITHDRAWAL: 10000,
		ASSET_INCREMENT_AMOUNT: 0.001,
		ASSET_ACTIVATE: true,
		ASSET_ICON: '',
		deposit: {},
		withdraw: {}
	},
	eth: {
		IS_DEFAULT: true,
		ASSET_NAME: 'Ethereum',
		ASSET_SYMBOL: 'eth',
		ASSET_COLOR: '#3e4ea1',
		ASSET_ALLOW_DEPOSITS: true,
		ASSET_ALLOW_WITHDRAWAL: true,
		ASSET_PROMOTE: false,
		ASSET_WITHDRAWAL_FEE: 0.001,
		ASSET_MINIMUM_WITHDRAWAL: 0.001,
		ASSET_MAXIMUM_WITHDRAWAL: 10000,
		ASSET_INCREMENT_AMOUNT: 0.001,
		ASSET_ACTIVATE: true,
		ASSET_ICON: '',
		deposit: {},
		withdraw: {}
	},
	bch: {
		IS_DEFAULT: true,
		ASSET_NAME: 'Bitcoin Cash',
		ASSET_SYMBOL: 'bch',
		ASSET_COLOR: '#8dc541',
		ASSET_ALLOW_DEPOSITS: true,
		ASSET_ALLOW_WITHDRAWAL: true,
		ASSET_PROMOTE: false,
		ASSET_WITHDRAWAL_FEE: 0.001,
		ASSET_MINIMUM_WITHDRAWAL: 0.001,
		ASSET_MAXIMUM_WITHDRAWAL: 10000,
		ASSET_INCREMENT_AMOUNT: 0.001,
		ASSET_ACTIVATE: true,
		ASSET_ICON: '',
		deposit: {},
		withdraw: {}
	},
	usdt: {
		IS_DEFAULT: true,
		ASSET_NAME: 'Tether',
		ASSET_SYMBOL: 'usdt',
		ASSET_COLOR: '#8bc43f',
		ASSET_ALLOW_DEPOSITS: true,
		ASSET_ALLOW_WITHDRAWAL: true,
		ASSET_PROMOTE: false,
		ASSET_WITHDRAWAL_FEE: 0.001,
		ASSET_MINIMUM_WITHDRAWAL: 0.001,
		ASSET_MAXIMUM_WITHDRAWAL: 10000,
		ASSET_INCREMENT_AMOUNT: 0.001,
		ASSET_ACTIVATE: true,
		ASSET_ICON: '',
		deposit: {},
		withdraw: {}
	}
};

export const COIN_FULL_NAME = {
	btc: 'Bitcoin',
	bch: 'Bitcoin Cash',
	bsv: 'Bitcoin Satoshi Vision',
	hex: 'HollaEx',
	xht: 'HollaEx',
	usdt: 'USD Tether',
	bnb: 'BNB',
	leo: 'UNUS SED',
	mkr: 'Maker',
	usdc: 'USD Coin',
	bat: 'BAT',
	xmr: 'Monero',
	dai: 'DAI',
	xrp: 'Ripple',
	eos: 'EOS',
	ltc: 'Litecoin',
	xlm: 'Stellar',
	ada: 'Cardano',
	trx: 'Tron',
	neo: 'NEO',
	nem: 'NEM',
	eth: 'Ethereum',
	etc: 'Ethereum Classic',
	dash: 'Dash',
	miota: 'IOTA',
	zrx: 'ZRX',
	tusd: 'True USD',
	xaut: 'Gold Tether'
};

export const CONTACT_ACTIONS = [
	'Make a Payments',
	'Cancel Plan',
	'Mainnet Wallet',
	'HollaEx Kit',
	'API Keys',
	'Plugin',
	'Other'
];

export const AWS_REGIONS = [
	{ value: 'us-east-1', name: 'US East(N. Virginia)' },
	{ value: 'us-east-2', name: 'US East(Ohio)' },
	{ value: 'us-west-1', name: 'US West(N. California)' },
	{ value: 'us-west-2', name: 'US West(Oregon)' },
	{ value: 'ap-east-1', name: 'Asia Pacific(Hong Kong)' },
	{ value: 'ap-south-1', name: 'Asia Pacific(Mumbai)' },
	{ value: 'ap-northeast-2', name: 'Asia Pacific(Seoul)' },
	{ value: 'ap-southeast-1', name: 'Asia Pacific(Singapore)' },
	{ value: 'ap-southeast-2', name: 'Asia Pacific(Sydney)' },
	{ value: 'ap-northeast-1', name: 'Asia Pacific(Tokyo)' },
	{ value: 'ca-central-1', name: 'Canada(Central)' },
	{ value: 'eu-central-1', name: 'Europe(Frankfurt)' },
	{ value: 'eu-west-1', name: 'Europe(Ireland)' },
	{ value: 'eu-west-2', name: 'Europe(London)' },
	{ value: 'eu-west-3', name: 'Europe(Paris)' },
	{ value: 'eu-north-1', name: 'Europe(Stockholm)' },
	{ value: 'me-south-1', name: 'Middle east(Bahrain)' },
	{ value: 'sa-east-1', name: 'South America(São Paulo)' }
];

export const RUNNING_MESSAGE =
	'The exchange is already in running status. For changing your exchange configuration please navigate to your exchange website url and configure the settings on the admin panel.';

export const TABLE_BILLING_COLUMN = (exchange = {}, handleEdit = () => { }, handleDownload = () => { }) => {
	return [
		{
			title: 'Item',
			dataIndex: 'item',
			key: 'item',
			render: (item) => <div className="billing-package-text">{item}</div>
		},
		{
			title: 'Description',
			dataIndex: 'description',
			key: 'description',
			render: (description) => <div>{description}</div>
		},
		{
			title: 'Amount',
			dataIndex: 'amount',
			key: 'amount',
			render: (amount, item) => `${amount} ${item.currency.toUpperCase()}`
		},
		{
			title: 'Date',
			dataIndex: 'created_at',
			key: 'created_at',
			render: (date, item) => moment(date).format('MMM DD, YYYY')
		},
		{
			title: 'Time left',
			dataIndex: 'expiry',
			key: 'expiry',
			render: (date, item) => (
				item.is_paid
					? '---'
					: moment(date).diff(moment(), 'days') >= 1
						? `${moment(date).diff(moment(), 'days')} days`
						: '0 days'
			)
		},
		{
			title: 'Status',
			dataIndex: 'is_paid',
			key: 'is_paid',
			render: (isPaid, item) => {
				if (isPaid) {
					return <div className="download-text-wrapper">
						<Tag color="green">Paid</Tag>
					</div>
				} else if (moment().isAfter(moment(item.expiry))) {
					return <Tag color="red">Expired</Tag>;
				} else {
					return (
						<div>
							<span>
								<Link onClick={() => {
									handleEdit(item.id, item.item === "plugin", true);
								}}
									to={`/billing?id=${exchange.id}`}
								>
									Pay
								</Link>
							</span>
							&nbsp;
						</div>
					);
				}
			}
		},
		{
			title: 'Download',
			dataIndex: '',
			key: 'download',
			render: (isPaid, item) => {
				return <div style={{ textAlign: 'center' }}>
					<Icon type="download" onClick={() => handleDownload(item.id, item)} style={{ fontSize: '18px', color: '#808080' }} />
				</div>
			}
		},
	];
};

export const default_coin_data = {
	fullname: '',
	symbol: '',
	logo: '',
	withdrawal_fee: 0.001,
	min: 0.001,
	max: 10000,
	increment_unit: 0.001,
	// active: true,
	allow_deposit: true,
	allow_withdrawal: true,
	estimated_price: 1,
	meta: {
		color: '#000',
		decimal_points: 18,
		supply: 0
	},
	is_public: true
};

export const defaultRepo = 'https://github.com/hollaex/hollaex-kit.git';
export const defalutBranch = "master";
export const CONTACT_DESCRIPTION_LINK = 'https://metamask.zendesk.com/hc/en-us/articles/360015488811-What-is-a-Token-Contract-Address-';
export const YOUTUBE_CHANNEL_LINK = 'https://youtube.com/channel/UCobspC2mT1Qwx2k2u5zDZiw';
